module.exports = __webpack_public_path__ + "img/tab_shouye.b09afd44.png";